// =========================================
// Service Slider
// Draggable, variable-width card slider (Figma 329:6424)
// Swiper comes from the shared swiper-core bundle (window.Swiper).
// =========================================
document.addEventListener('DOMContentLoaded', function () {
    const Swiper = window.Swiper;
    const { FreeMode, Mousewheel } = window.SwiperModules || {};
    if (!Swiper) return;

    const sliders = document.querySelectorAll('[data-service-slider]');
    if (!sliders.length) return;

    sliders.forEach(function (el) {
        new Swiper(el, {
            modules: [FreeMode, Mousewheel].filter(Boolean),
            slidesPerView: 'auto',
            spaceBetween: 20,
            freeMode: true,
            grabCursor: true,
            mousewheel: { forceToAxis: true },
        });
    });
});
